import { get } from 'lodash';
import * as React from 'react';

// @ts-ignore
import AdminStatisticsCommunicationChart from 'admin/components/AdminStatisticsCommunicationChart';
// @ts-ignore
import { formatData } from 'admin/lib/Chart';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Container from 'components/Container';
import Image from 'components/Image';
import Row from 'components/Row';
import LinkConstants from 'constants/LinkConstants';
import EngagementRatings, { EngagementRating } from 'organizations/constants/EngagementRatings';

import OrganizationEngagementViewChartFigure from './OrganizationEngagementViewChartFigure';
import OrganizationEngagementViewContainer from './OrganizationEngagementViewContainer';
import { Stats } from './OrganizationEngagementViewDataContainer';
import OrganizationEngagementViewHeading from './OrganizationEngagementViewHeading';

type Props = {
  activeUsersCount?: number,
  eventKey: string;
  name?: string,
  schoolRating?: EngagementRating | undefined;
  stats?: Stats | undefined;
  utmParams: string;
}

export default function OrganizationEngagementViewEngagement({
  activeUsersCount,
  eventKey,
  name,
  schoolRating,
  stats,
  utmParams,
}: Props) {
  return (
    <div className="OrganizationEngagementViewEngagement">
      <Row>
        <OrganizationEngagementViewContainer>
          <OrganizationEngagementViewHeading align="center">
            {activeUsersCount && name ? (
              <React.Fragment>
                <span className="OrganizationEngagementView--highlight">
                  {activeUsersCount.toLocaleString()} teachers, students, and parents
                </span>{' '}
                at {name} are actively communicating on Remind.
              </React.Fragment>
            ) : (
              <React.Fragment>
                Measure{' '}
                <span className="OrganizationEngagementView--highlight">
                  community engagement
                </span>{' '}
                at your district with Remind.
              </React.Fragment>
            )}
          </OrganizationEngagementViewHeading>
        </OrganizationEngagementViewContainer>
      </Row>
      <Container size="large">
        {stats && schoolRating && (
          <Row>
            <OrganizationEngagementViewChartFigure
              title={
                get(stats, 'communication_usage.chart')
                  ? `Messages delivered at ${name} in the last 6 months`
                  : `See how many messages were delivered at ${name} in the last 6 months`
              }
              chartType="communication"
              copy="Most school engagement takes place at the classroom level, including class updates and two-way communication between teachers and families.">
              {get(stats, 'communication_usage.chart') ? (
                <AdminStatisticsCommunicationChart
                  announcementsColor={EngagementRatings.COLORS[schoolRating].light}
                  conversationsColor={EngagementRatings.COLORS[schoolRating].dark}
                  data={formatData(stats.communication_usage.chart, 'month')}
                  height={320}
                  simple
                  tooltip
                />
              ) : (
                <Image
                  src={require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewEngagement/communication-chart---null.png')}
                  srcSet={`${require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewEngagement/communication-chart---null@2x.png')} 2x`}
                  full
                />
              )}
            </OrganizationEngagementViewChartFigure>
          </Row>
        )}
        <Buttons align="center">
          <Button
            to={`${LinkConstants.ADMIN_UPGRADE}?${utmParams}&utm_content=callout`}
            eventKey={`${eventKey}.content_footer.cta.click`}>
            Learn more about engagement in your district
          </Button>
        </Buttons>
      </Container>
    </div>
  );
}
